import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { ClasseVeicolo } from '@app/shared/models/assistenza';
import { UtilityService } from '@app/shared/services/utility.service';

@Component({
  selector: 'ser-classe-veicolo-select',
  templateUrl: './classe-veicolo-select.component.html',
  styleUrl: './classe-veicolo-select.component.scss'
})
export class ClasseVeicoloSelectComponent {
  
  @Input() control: UntypedFormControl;
  @Input() label: string = "assistenze.fields.classeVeicolo";
  @Input() readonly: boolean = false;

  classi: IS1InputSelectItem[];

  constructor(private utils: UtilityService) {
    this.classi = this.utils.getInputSelectFromEnum(ClasseVeicolo);
  }
}
